import {
  BaseListItem,
  BaseListPager,
  Wireframe
} from '@did/das-balance-components'
import { useRecords } from '@did/das-balance-hooks'
import { RecordListType } from '@did/das-balance-types'
import React, { useMemo } from 'react'
import { HistoryItem } from './history-item'
import styles from './styles.module.scss'
import { useDasBalanceContext } from '@did/das-app-context'
import { RecordStatusFilter } from '../RecordStatusFilter'
import {
  EnumRecordStatusFilters,
  IRecordStatusFilterOption
} from '@did/das-balance-types'

export const RecordList: RecordListType = ({
  NotFound,
  className,
  balance
}) => {
  const { tt } = useDasBalanceContext()
  const {
    filter,
    setFilter,
    recordList,
    loading,
    currPage,
    setCurrPage,
    pages
  } = useRecords(balance)

  const onFilter = (value: EnumRecordStatusFilters) => {
    setFilter(value)
    setCurrPage(1)
  }

  const filterOptions = useMemo((): IRecordStatusFilterOption[] => {
    return [
      {
        label: tt('All'),
        value: EnumRecordStatusFilters.all
      },
      {
        label: tt('Top Up'),
        value: EnumRecordStatusFilters.topUp
      },
      {
        label: tt('Withdraw'),
        value: EnumRecordStatusFilters.withdraw
      },
      {
        label: tt('Expenditures'),
        value: EnumRecordStatusFilters.expenditures
      }
    ]
  }, [tt])

  return (
    <div className="shadow-sm border border-gray-200 bg-white rounded-3xl mt-3 overflow-hidden pb-4">
      <div className="flex items-center justify-between text-base font-bold p-4">
        <span>{tt('Records')}</span>
        <RecordStatusFilter
          value={filter}
          className="w-[130px] rounded-lg"
          options={filterOptions}
          onInput={onFilter}
        />
      </div>
      <div className={`${styles.accountList} ${className}`}>
        {loading &&
          Array.from({ length: 10 }).map((_, i) => (
            <BaseListItem
              key={i}
              className={styles.listItem}
              head={<Wireframe shape="circle" height="24" width="24" />}
              tail={<Wireframe shape="round" height="20" width="100" />}
            >
              <Wireframe shape="round" height="20" width="100" />
            </BaseListItem>
          ))}

        {!loading &&
          recordList.length > 0 &&
          recordList.map((recordInfo, i) => (
            <HistoryItem key={i} recordInfo={recordInfo} />
          ))}
        {!loading && !recordList.length && (
          <NotFound
            title={tt('No records')}
            iconName="explorer-details"
            className="pb-14 my-8"
          />
        )}
        {pages > 1 && (
          <BaseListPager
            className={styles.baseListPager}
            current={currPage}
            pages={pages}
            onChange={setCurrPage}
            noItems
          />
        )}
      </div>
    </div>
  )
}
